module.exports = __webpack_public_path__ + "static/media/conversion_2_green.81b78e61.png";